import React, { useEffect, useState } from "react";
import { Await, Link, useNavigate } from "react-router-dom";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import CallAPI from "../../services/apiCalls";
import useUserStore from "../../utils/storeApp"; //
import EditUser from "./EditUser";
import DetailsUser from "./DetailsUser";
import AssignOrgEmail from "../shared/AssignOrgEmail";
import TwoFactor from "./TwoFactor";
import UserEmailList from "./UserEmailList";
import { Tag } from "primereact/tag";
import $ from "jquery";
import SearchUser from "./SearchUser";
import { Dropdown } from "primereact/dropdown";

const gridStyle = { minHeight: 550 };
const ListUser = () => {
  const {
    isUserLogedIn,
    userRole,
    userToken,
    sharedObject,
    SetSharedObject,
    userSession,
  } = useUserStore((state) => ({
    isUserLogedIn: state.isUserLogedIn,
    userRole: state.userRole,
    userToken: state.userToken,
    sharedObject: state.sharedObject,
    SetSharedObject: state.SetSharedObject,
    userSession: state.userSession,
  }));
  const [userObj, setUserObj] = useState([]);
  const [emailListObj, setEmailListObj] = useState({});
  const [customerObj, SetCustomerObj] = useState([]);
  const [orgObj, SetOrgObj] = useState([]);
  const [userDetails, setUserDetails] = useState(false);
  const [userEditDetails, setUserEditDetails] = useState(false);
  const [showGridFlag, SetShowGridFlag] = useState(
    userRole === "SES ADMINISTRATOR" ? false : true
  );
  const [selectedGridProducts, setSelectedGridProducts] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [nameSearch, setNameSearch] = useState(null);
  const [customerCustVal, setCustomerCustVal] = useState(null);
  const [customerOrgVal, setCustomerOrgVal] = useState(null);
  const [answers, setAnswers] = useState();
  const [processing, setProcessing] = useState(false);
  const [processingUserAction, setProcessingUserAction] = useState(false);
  const [showUserEmailFlag, setShowUserEmailFlag] = useState(false);
  const setAnswer = async (questionId, answer) => {
    await setAnswers({ ...answers, [questionId]: answer });
  };
  const [errDetailFlag, SetErrDetailFlag] = useState(false);
  const [errDetailMsg, SetErrDetailsMsg] = useState(false);
  const [custFlag, SetCustFlag] = useState(false);
  const [showBackBtn, SetShowBackBtn] = useState(false);
  const [userOrgId, setUserOrgId] = useState(null);
  const [userOrgName, setUserOrgName] = useState("List");
  const [nrVal, SetNrVal] = useState(0);
  const [showDetails, setShowDetails] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    setUserDetails(false);
    SetShowBackBtn(false);
    SetCustomerObj(sharedObject.vendorsObj);
    let obj = sharedObject.UserIdEmail;
    if (userRole === "SES ADMINISTRATOR") {
      if (obj && Object.keys(obj).length > 0 && obj.constructor === Object) {
        setUserOrgName(obj.Name);
        usersList(obj);
      }
    } else {
      if (obj && Object.keys(obj).length > 0 && obj.constructor === Object) {
        setUserOrgName(obj.Name);
        usersList(obj);
      } else {
        let serch = {
          AdminsOnly: false,
        };
        usersList(serch);
      }
    }
    if (sharedObject.reloadEmailList) {
      SelectUsersByOrgId(customerOrgVal);
    }
    return () => {
      SetSharedObject("reloadEmailList", false);
    };
  }, [sharedObject.reloadEmailList]);

  const usersList = async (mdl) => {
    setCurrentUser(mdl);
    setProcessing(true);
    let call = "/users/GetUsers";
    const res = await CallAPI(call, mdl, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    await SetSharedObject("GetUserObj", mdl);
    setProcessing(false);
    if (res.status === "SUCCESS") {
      SetShowGridFlag(true);
      if (sharedObject.FromOrg === true) {
        setUserOrgName(sharedObject.UserIdEmail.Name);
        SetSharedObject("FromOrg", false);
      }
      let dt = res.data.data.pageItems;
      let tempObj = [];
      let opt = [
        "Add Email",
        "Assign Email",
        "Lock",
        "Unlock",
        "Reset Password",
        "Delete",
      ];
      for (const row of dt) {
        let cs = (
          <a
            href="javascript:void(0);"
            underline="none"
            className="font-weight-bold"
            onClick={() => {
              userEdit(row, "show");
            }}
          >
            {row.userNameDisplay}
          </a>
        );
        row.EditCourse = cs;
        let select = (
          <select
            onChange={(el) => {
              userActions(row, el.target.value);
            }}
            value={nrVal}
            id="UserActions"
            className="form-control form-control-sm p-0 ht-4"
          >
            <option value="">Select</option>
            {opt.map((el, i) => {
              return row.status === "Locked" &&
                el === "Lock" ? null : row.status === "Active" &&
                el === "Unlock" ? null : row.status === "Pending" &&
                (el === "Lock" || el === "Unlock") ? null : (
                <option key={i} value={el}>
                  {el}
                </option>
              );
            })}
          </select>
        );
        row.Actions = select;
        row.dCreated = new Date(row.dateCreated);
        tempObj.push(row);
      }
      setUserObj(tempObj);
      let obj = sharedObject.TwoFactorObject;
      if (
        obj &&
        Object.keys(obj).length > 0 &&
        obj.constructor === Object &&
        !showDetails
      ) {
        userEdit({
          ...obj,
          usrTFA: userDetails.userContact.status === "Active",
          oName: userDetails.oName,
          orgTFA: userDetails.orgTFA,
          orgId: userDetails.orgId,
        });
      }
    } else if (res.status === "SERVERERROR") {
      let msg = res.data;
      let str = "<div>";
      for (let el of msg) {
        str += `${el}`;
      }
      str += "</div>";
      SetErrDetailsMsg(str);
      SetErrDetailFlag(true);
      setProcessing(false);
    }
  };
  const userEdit = async (row, type) => {
    SetErrDetailFlag(false);
    SetErrDetailsMsg(false);
    setShowDetails(false);
    if (type === "edit") {
      $("#editUserModal").modal("show");
    } else {
      setProcessing(true);
      setSelectedGridProducts([row]);
      let call = "/users/getUserById?userId=" + row.id;
      const res = await CallAPI(call, false, "get", userToken);
      await SetSharedObject("ResponseCode", res.code);
      if (res.status === "SUCCESS") {
        let det = res.data.data;
        let usrTFA = row.status === "Active";
        setUserDetails({
          ...det,
          usrTFA: usrTFA,
          oName: row.orgName,
          orgTFA: row.orgTFA,
          orgId: row.orgId,
        });
        setUserEditDetails({
          ...det.userContact,
          usrTFA: usrTFA,
          oName: row.orgName,
          orgTFA: row.orgTFA,
          orgId: row.orgId,
        });
        setAnswers(det);
        if (row.id === parseInt(userSession.sesuser_id)) {
          //SetSharedObject("getUserEmails", det.userEmails);
        }
        await SetSharedObject("specialties", det.userContact.specialties);
        await SetSharedObject("selectedUser", det.userContact);
        $("#detailsUserModal").modal("show");
      } else if (res.status === "SERVERERROR") {
        let str =
          "We have encountered a system error. Please try again and contact support if the problem persists.";
        SetErrDetailsMsg(str);
        SetErrDetailFlag(true);
        setProcessing(false);
      }
      setProcessing(false);
    }
    //navigate("/test");
  };
  const [customerName, SetCustomerName] = useState("");
  const CustomerIdSet = async (el) => {
    setCustomerCustVal(el);
    if (el === "") {
      SetOrgObj([]);
      return;
    }
    SetShowGridFlag(false);
    setProcessing(true);
    let call = "/users/GetOrgsByCustID?vendorID=" + parseInt(el);
    const res = await CallAPI(call, false, "get", userToken);
    setProcessing(false);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      setProcessing(false);
      SetOrgObj(res.data.data);
      //SetShowGridFlag(true);
    } else if (res.status === "SERVERERROR") {
      let msg = res.data;
      let str = "<div>";
      for (let el of msg) {
        str += `${el}`;
      }
      str += "</div>";
      SetErrDetailsMsg(str);
      SetErrDetailFlag(true);
      setProcessing(false);
    }
    setProcessing(false);
  };
  const SelectUsersByOrgId = async (vl) => {
    SetCustFlag(false);
    SetSharedObject("UserIdEmail", 0);
    SetSharedObject("reloadEmailList", false);
    setCustomerOrgVal(vl);
    let val = vl.split(",");
    let orgId = val[0];
    setUserOrgId(orgId);
    setUserOrgName(val[1]);
    SetShowGridFlag(true);
    let serch = {};
    serch.OrganizationId = orgId;
    usersList(serch);
  };
  const [currentUser, setCurrentUser] = useState({});

  const getSeverity = (product) => {
    switch (product.status) {
      case "Active":
        return "success";
      case "Pending":
        return "warning";
      case "IDP Failed and Locked":
        return "danger";
      case "Failed":
        return "danger";
      case "Locked":
        return "danger";
      default:
        return null;
    }
  };

  const imageBodyTemplate = (product) => {
    let s = (
      <>
        <Tag value={product.status} severity={getSeverity(product)}></Tag>
        {product.orgTFA === true && product.status === "Active" ? (
          <>
            {product.tfaOn ? (
              <a
                href="javascript:void(0);"
                className="bi bi-shield-fill-check"
                alt="Two-Factor Authentication Enabled Icon"
                title="Two-Factor Authentication Enabled"
                onClick={(el) => {
                  setShowDetails(true);
                  userActions(product, "twoFactorCheck");
                }}
              />
            ) : (
              <a
                href="javascript:void(0);"
                className="bi bi-shield-slash gray"
                alt="Two-Factor Authentication Disabled Icon"
                title="Two-Factor Authentication Disabled"
                onClick={(el) => {
                  setShowDetails(true);
                  userActions(product, "twoFactorCheck");
                }}
              />
            )}
          </>
        ) : null}
      </>
    );
    return s;
  };
  const [successMsg, setSuccessMsg] = useState(false);
  const [successMsgFlag, setSuccessMsgFlag] = useState(false);
  const [actionRow, setActionRow] = useState({});
  const [submitFlag, setSubmitFlag] = useState(false);
  const [reasonFlag, setReasonFlag] = useState(false);
  const [deleteReasonFlag, setDeleteReasonFlag] = useState("");
  const [errCreateMsg, SetErrCreateMsg] = useState(false);
  const [errMsg, SetErrMsg] = useState(false);
  const [lockReason, setLockReason] = useState("");
  const [deleteReason, setDeleteReason] = useState("");
  const [valTwoFactor, SeValTwoFactor] = useState({});
  const [idVal, SetIdVal] = useState("UserDeleteConfirmModal");
  const [headTitle, SetHeadTitle] = useState("Delete Confirmation");
  const [modalBodyText, SetModalBodyText] = useState("");
  const getDirectEmails = async (el) => {
    setProcessing(true);
    let call =
      "/organization/GetDirectEmails?orgId=" +
      parseInt(el.orgId) +
      "&userId=" +
      parseInt(el.id);
    const res = await CallAPI(call, false, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      setProcessing(false);
      return res.data.data;
    } else if (res.status === "SERVERERROR") {
      let msg = res.data;
      let str = "<div>";
      for (let el of msg) {
        str += `${el}`;
      }
      str += "</div>";
      SetErrDetailsMsg(str);
      SetErrDetailFlag(true);
      setProcessing(false);
    }
  };
  const userActions = async (row, val) => {
    setActionRow(row);
    setReasonFlag(false);
    setShowUserEmailFlag(false);
    setSubmitFlag(false);
    setEmailListObj({});
    setSuccessMsg(false);
    setSuccessMsgFlag(false);
    setDeleteReasonFlag(false);
    SetErrCreateMsg(false);
    await setSelectedGridProducts([row]);
    if (val === "") return;
    if (val === "Assign Email") {
      const emls = await getDirectEmails(row);
      if (emls.length === 0) {
        SetIdVal("AssignEmail");
        SetHeadTitle("Assign Email");
        $("#ActionModal").modal("show");
        return;
      }
      let tmp = [];
      emls.map((el) => {
        if (el.emailList.length === 1 && !el.sharingAllowed) {
        } else {
          tmp.push(el);
        }
      });
      if (tmp.length === 0) {
        SetIdVal("AssignEmail");
        SetHeadTitle("Assign Email");
        $("#ActionModal").modal("show");
        return;
      }
      await setSelectedProducts(tmp);
      $("#SharedOrgEmailModal").modal("show");
    }
    if (val === "Delete") {
      SetIdVal("UserDeleteConfirmModal");
      SetHeadTitle("Delete Confirmation");
      setSuccessMsgFlag(false);
      $("#ActionModal").modal("show");
    } else if (val === "twoFactorCheck") {
      SetSharedObject("TwoFactorObject", row);
      SeValTwoFactor(row);
      $("#TwoFactorSettingModal").modal("show");
    } else if (val === "Add Email") {
      setEmailListObj(row);
      setShowUserEmailFlag(true);
      $("#UsrEmailList").modal("show");
    } else if (val === "Lock") {
      SetIdVal("Lock");
      SetHeadTitle("Lock User Account");
      $("#ActionModal").modal("show");
    } else if (val === "Unlock") {
      SetIdVal("Unlock");
      SetHeadTitle("Unlock User Account");
      $("#ActionModal").modal("show");
    } else if (val === "Reset Password") {
      SetIdVal("ResetPassword");
      SetHeadTitle("Send Reset Password");
      $("#ActionModal").modal("show");
    }
  };
  const handleUserActions = async () => {
    setDeleteReasonFlag(false);
    setSubmitFlag(true);
    setSuccessMsg(false);
    SetErrMsg("");
    SetErrCreateMsg(false);
    setSuccessMsgFlag(false);
    if (idVal === "Lock" || idVal === "Unlock") {
      if (lockReason === "" && idVal === "Lock") {
        setReasonFlag(true);
      } else {
        setReasonFlag(false);
        setProcessingUserAction(true);
        let call = "";
        if (idVal === "Lock") {
          call =
            "/users/LockUsers?key=" +
            actionRow.id +
            "&reason=" +
            lockReason +
            "&value=" +
            actionRow.userName;
          setSuccessMsg(`${actionRow.accountName} was successfully locked.`);
        } else {
          call =
            "/users/UnlockUsers?key=" +
            actionRow.id +
            "&value=" +
            actionRow.userName;
          setSuccessMsg(`${actionRow.accountName} was successfully unlocked.`);
        }
        const res = await CallAPI(call, false, "get", userToken);
        await SetSharedObject("ResponseCode", res.code);
        if (res.status === "SUCCESS") {
          SetSharedObject("UserIdEmail", 0);
          setProcessingUserAction(false);
          setSuccessMsgFlag(true);
          usersList(currentUser);
          $(".modal").modal("hide");
        } else if (res.status === "SERVERERROR") {
          let msg = res.data[actionRow.userName];
          let str = "<div>";
          for (let el of msg) {
            str += `${el}`;
          }
          str += "</div>";
          SetErrMsg(str);
          SetErrCreateMsg(true);
          setProcessingUserAction(false);
        }
      }
    } else if (idVal === "UserDeleteConfirmModal") {
      if (deleteReason === "") {
        setDeleteReasonFlag(true);
      } else {
        setDeleteReasonFlag(false);
        setProcessingUserAction(true);
        const temp = [];
        for (const elem of selectedGridProducts) {
          let o = {
            Key: elem.id,
            Value: elem.userName,
          };
          temp.push(o);
        }
        let delUsers = JSON.stringify(temp);
        let call = "/users/DeleteUsers?reason=" + deleteReason;
        const res = await CallAPI(call, delUsers, "post", userToken);
        await SetSharedObject("ResponseCode", res.code);
        if (res.status === "SUCCESS") {
          SetSharedObject("UserIdEmail", 0);
          setProcessingUserAction(false);
          setSuccessMsg(`Deleted Successfully!`);
          setSuccessMsgFlag(true);
          usersList(currentUser);
          setSelectedGridProducts([]);
        } else if (
          res.status === "SERVERERROR" ||
          res.returnMessage === "SERVERERROR"
        ) {
          let str =
            "<div>System encountered an error. Please try again. If the problem persists, please contact your administrator.</div>";
          SetErrMsg(str);
          SetErrCreateMsg(true);
          setProcessingUserAction(false);
        }
      }
    } else if (idVal === "ResetPassword") {
      setDeleteReasonFlag(false);
      setProcessingUserAction(true);

      let call = "/admin/ResetPassword?Id=" + actionRow.id;
      const res = await CallAPI(call, false, "get", userToken);
      await SetSharedObject("ResponseCode", res.code);
      if (res.status === "SUCCESS") {
        SetIdVal("confirmPasswordResetSuccess");
        SetHeadTitle("Confirmed");
        let str = (
          <>
            <div className="message-wrapper">
              The password was successfully reset and an email notification has
              been sent.
            </div>
          </>
        );
        setSuccessMsg(str);
        setSuccessMsgFlag(true);
        setProcessingUserAction(false);
      } else if (
        res.status === "SERVERERROR" ||
        res.returnMessage === "SERVERERROR"
      ) {
        let str =
          "<div>System encountered an error. Please try again. If the problem persists, please contact your administrator.</div>";
        SetErrMsg(str);
        SetErrCreateMsg(true);
        setProcessingUserAction(false);
      }
    }
  };
  const handleAssignEmailToUsers = async (el) => {
    if (selectedGridProducts.length === 0) {
      SetHeadTitle("Alert");
      let str = (
        <div className="modal-body">
          <div className="ctr sp-pad3">
            There was nothing selected to assign email.
          </div>
        </div>
      );
      SetModalBodyText(str);
      $("#AlertModal").modal("show");
      return;
    } else {
      let o = { orgId: userOrgId, id: 0 };
      const emls = await getDirectEmails(o);
      if (emls.length === 0) {
        SetIdVal("AssignEmail");
        SetHeadTitle("Assign Email");
        $("#ActionModal").modal("show");
        return;
      }
      await setSelectedProducts(emls);
      $("#SharedOrgEmailModal").modal("show");
      //userActions(selectedGridProducts, "Assign Email");
    }
  };

  const [showDeleteFlag, setShowDeleteFlag] = useState(true);
  const handleDeleteUsers = () => {
    setSuccessMsgFlag(false);
    SetErrCreateMsg(false);
    setDeleteReason("");
    if (selectedGridProducts.length === 0) {
      SetHeadTitle("Alert");
      let str = (
        <div className="modal-body">
          <div className="ctr sp-pad3">
            There was nothing selected to delete.
          </div>
        </div>
      );
      SetModalBodyText(str);
      $("#AlertModal").modal("show");
    } else {
      SetHeadTitle("Delete Confirmation");
      SetIdVal("UserDeleteConfirmModal");
      $("#ActionModal").modal("show");
    }
  };
  const SearchForUsers = () => {
    SetCustFlag(false);
    SetSharedObject("UserIdEmail", 0);
    SetShowGridFlag(true);
    let serch = {};
    let nm = nameSearch.split(" ");
    serch.FirstName = nm[0];
    serch.LastName = nm[1];
    //serch.UserName = nameSearch;
    usersList(serch);
  };
  const SearchWithEnter = (e) => {
    if (e.key === "Enter") {
      SearchForUsers();
    }
  };
  const updateUser = async (usr) => {
    let o = {
      ...userDetails.userContact,
      usrTFA: userDetails.userContact.status === "Active",
      oName: userDetails.oName,
      orgTFA: userDetails.orgTFA,
      orgId: userDetails.orgId,
    };
    userEdit(o, "detail");
  };
  const handleEdit = () => {
    let o = {
      ...userDetails.userContact,
      usrTFA: userDetails.userContact.status === "Active",
      oName: userDetails.oName,
      orgTFA: userDetails.orgTFA,
      orgId: userDetails.orgId,
    };
    userEdit(o, "detail");
  };
  const userSearchObj = async (obj) => {
    SetCustFlag(false);
    SetSharedObject("UserIdEmail", 1);
    SetShowGridFlag(true);
    $("#advUserSearchModal").modal("hide");
    usersList(obj);
  };
  const showParent = (flag) => {
    if (flag) {
      if (sharedObject.UserIdEmail.Navigate === "detailUser") {
        navigate("/emails");
      } else if (sharedObject.UserIdEmail.Navigate === "org") {
        navigate("/organizations");
      }
    } else {
      setUserOrgName("List");
      SetShowBackBtn(false);
    }
  };
  const userDetEdit = (row) => {
    setUserEditDetails(row);
    $("#editUserModal").modal("show");
  };

  const dateCreatedDate = (dt) => {
    return dt.dateCreated ? new Date(dt.dateCreated).toLocaleString() : null;
  };
  const [sortFlag, SetSortFlag] = useState(false);
  const nameBodyTemplate = (product) => {
    SetSortFlag(!sortFlag);
    if (sortFlag)
      userObj.sort((a, b) =>
        a.userNameDisplay.localeCompare(b.userNameDisplay)
      );
    else
      userObj.sort((a, b) =>
        b.userNameDisplay.localeCompare(a.userNameDisplay)
      );
  };
  return (
    <div className="ListUser">
      <div className="HeaderTools">
        <header className="ht-6">
          <div className="spacer-inline">
            {(showBackBtn || custFlag) &&
            sharedObject.UserIdEmail.Navigate !== "Users" ? (
              <div className="spacer-inline btnback-container-1">
                <a
                  href="javascript:void(0);"
                  onClick={(el) => showParent(custFlag)}
                >
                  <i className="bi bi-arrow-left-square-fill"></i>
                </a>
              </div>
            ) : null}
            <div className="title-label4">
              {sharedObject.UserIdEmail?.Flag === "orgDetails"
                ? `Organization: ${userOrgName}`
                : sharedObject.UserIdEmail?.Flag === "orgEmails"
                ? `${userOrgName}`
                : sharedObject.UserIdEmail?.Flag === "adminUserOrgDetails"
                ? `Admins for  ${userOrgName}`
                : sharedObject.UserIdEmail?.Flag === "userOrgDetails"
                ? `Users for  ${userOrgName}`
                : `List`}
            </div>
          </div>
          <div className="mid-header-bar">
            <div className="OrgDropdown spacer-inline">
              <aside>
                {/*Customer Dropdown List SES Admins only*/}
                {userRole !== "SES ADMINISTRATOR" ? null : (
                  <>
                    <Dropdown
                      value={selectedCustomer}
                      onChange={(e) => {
                        setSelectedCustomer(e.value);
                        CustomerIdSet(e.value?.id);
                      }}
                      options={customerObj}
                      optionLabel="name"
                      placeholder="Customers"
                      filter
                      className="form-control w-md2 spacer-margin5"
                    />

                    <Dropdown
                      value={customerOrgVal}
                      onChange={(e) => {
                        const selectedValue = e.value;
                        if (selectedValue) {
                          SelectUsersByOrgId(selectedValue); // or use id only, if needed
                        }
                      }}
                      options={orgObj.map((el) => ({
                        label: el.name,
                        value: `${el.id},${el.name}`,
                      }))}
                      placeholder="Organizations"
                      filter
                      className="form-control w-md2 spacer-margin5"
                    />
                  </>
                )}
              </aside>
            </div>
            {/*Search by name*/}
            <div className="spacer-inline spacer-margin5">
              <div className="input-group">
                <input
                  type="search"
                  className="form-control"
                  placeholder="Search by First Name"
                  aria-label="Enter Name"
                  aria-describedby="Search First Name"
                  value={nameSearch}
                  onChange={(el) => setNameSearch(el.target.value)}
                  onKeyPress={SearchWithEnter}
                />
                <div className="input-group-append">
                  <button
                    className="input-group-text btn btn-secondary"
                    id="basic-addon2"
                    onClick={SearchForUsers}
                  >
                    <i className="bi bi-search"></i>
                  </button>
                </div>
              </div>
            </div>

            {/*Advanced Search*/}
            <div className="spacer-inline">
              <button
                className="btn btn-primary"
                data-target="#advUserSearchModal"
                data-toggle="modal"
              >
                Adv Search
              </button>
            </div>
          </div>
        </header>
      </div>
      {/* <section className="sp-margin1">
        {errDetailFlag ? (
          <div
            className={`alert alert-danger`}
            dangerouslySetInnerHTML={{ __html: errDetailMsg }}
          />
        ) : null}
      </section> */}
      {showGridFlag ? (
        <section className="grid-layout">
          <div>
            <DataTable
              value={userObj}
              paginator
              selectionPageOnly
              rows={10}
              rowsPerPageOptions={[10, 25, 50]}
              tableStyle={{ minWidth: "50rem" }}
              paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
              currentPageReportTemplate="{first} to {last} of {totalRecords}"
              selectionMode={"checkbox"}
              selection={selectedGridProducts}
              onSelectionChange={(e) => {
                setSelectedGridProducts(e.value);
              }}
              selectionAutoFocus={false}
              dataKey="id"
              sortField="dCreated"
              sortOrder={-1}
            >
              <Column selectionMode="multiple" className="w-s"></Column>
              <Column
                field="EditCourse"
                header="Username"
                sortable
                sortField={(e) => nameBodyTemplate(e)}
              ></Column>
              <Column field="firstName" header="First Name" sortable></Column>
              <Column field="lastName" header="Last Name" sortable></Column>
              <Column
                field="contactEmail"
                header="Contact Email"
                sortable
              ></Column>
              <Column field="orgName" header="Organization" sortable></Column>
              <Column
                field="dCreated"
                header="Date Created"
                className="w-md8"
                body={dateCreatedDate}
                sortable
              ></Column>
              <Column
                field="status"
                header="Status"
                className="w-md11"
                body={imageBodyTemplate}
                sortable
              ></Column>
              <Column
                field="Actions"
                header="Actions"
                className="w-md2"
              ></Column>
            </DataTable>
          </div>
          <div className="paging">
            <div className="spacer-inline spacer-margin9">
              <button
                className="btn btn-outline-secondary"
                onClick={(e) => handleDeleteUsers()}
              >
                {" "}
                Delete{" "}
              </button>
              {/* <button
                className="btn btn-primary spacer-margin2"
                onClick={(e) => handleAssignEmailToUsers()}
              >
                Assign Email
              </button> */}
            </div>
          </div>
          {processing ? <div className="loading"></div> : null}
        </section>
      ) : (
        <section className="empty-grid">
          There are currently no results.
        </section>
      )}

      <div
        className="modal fade"
        id={"ActionModal"}
        data-backdrop="static"
        data-keyboard="false"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="User Delete Confirmation"
        aria-hidden="false"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <div className="modal-title">{headTitle}</div>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                {" "}
                <span aria-hidden="false">&times;</span>{" "}
              </button>
            </div>
            <div className="modal-body">
              {idVal === "Lock" ? (
                <div className="modal-content-body">
                  <div className="descript-container">
                    Are you sure you want to lock
                    <b>{actionRow.accountName}'s</b> account? User will no
                    longer have access to the portal.
                  </div>
                  <div className="modal-content-form">
                    <div className="field-wrapper">
                      <label>Reason</label>
                      <input
                        className="form-control"
                        value={lockReason}
                        onChange={(el) => setLockReason(el.target.value)}
                      />
                      <div className="sp-margin3">
                        Please provide a reason why you are locking this user.
                      </div>
                      {reasonFlag ? (
                        <div className="alert alert-danger field-wrapper">
                          Reason field is required.
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              ) : idVal === "Unlock" ? (
                <div className="message-wrapper sp-margin4">
                  Are you sure you want to unlock{" "}
                  <b>{actionRow.accountName}'s</b> account? User will continue
                  to have full access to the portal.
                </div>
              ) : idVal === "ResetPassword" ? (
                <div className="message-wrapper sp-margin4">
                  A password reset link will be sent to{" "}
                  <b>{actionRow.accountName}</b> with instructions on how to
                  reset password.
                </div>
              ) : idVal === "AssignEmail" ? (
                <div className="sp-pad3 ctr">
                  There are currently no Direct emails to assign for this
                  organization.
                </div>
              ) : (
                <>
                  <div className="descript2-container">
                    All Direct emails and information associated with the users
                    listed below will be permanently deleted and cannot be
                    undone.
                  </div>
                  <div className="modal-content-form">
                    <div className="field-wrapper">
                      <label>Are you sure you want to delete?</label>
                      <ul>
                        {selectedGridProducts.map((el) => (
                          <li key={el.id}>{el.userNameDisplay}</li>
                        ))}
                      </ul>
                    </div>
                    <div>
                      <label>Reason</label>
                      <input
                        className="form-control"
                        type="text"
                        value={deleteReason}
                        onChange={(e) => {
                          setDeleteReason(e.target.value);
                          if (e.target.value !== "" && submitFlag) {
                            setDeleteReasonFlag(false);
                          } else if (e.target.value === "" && submitFlag) {
                            setDeleteReasonFlag(true);
                          }
                        }}
                      />
                      {deleteReasonFlag && submitFlag ? (
                        <div className="alert alert-danger">
                          Your reason is required.
                        </div>
                      ) : null}
                      <div className="line-s1 sp-margin13">
                        Please provide a reason why you are deleting this
                        account.
                      </div>
                    </div>
                  </div>
                </>
              )}
              {errCreateMsg ? (
                <div
                  className={`alert alert-danger`}
                  dangerouslySetInnerHTML={{ __html: errMsg }}
                />
              ) : null}
              {successMsgFlag ? (
                <div className="screen-cover sp-pad5">
                  <div className="bi-success-check">
                    <i
                      className="bi bi-check2-circle"
                      alt="Success Checkmark"
                    ></i>
                  </div>
                  <div className="message-wrapper sp-mx3">{successMsg}</div>
                </div>
              ) : null}
            </div>
            <div className="modal-footer">
              {idVal === "confirmPasswordResetSuccess" ||
              idVal === "AssignEmail" ? null : showDeleteFlag &&
                !successMsgFlag ? (
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={(el) => handleUserActions()}
                >
                  Confirm
                </button>
              ) : null}
              <button
                type="button"
                className="btn btn-outline-secondary"
                data-dismiss="modal"
              >
                {successMsgFlag ? "Close" : "Cancel"}
              </button>
            </div>
            {processingUserAction ? <div className="loading"></div> : null}
          </div>
        </div>
      </div>
      {/* <AddEmail />
     Alert Dialog*/}
      <div
        className="modal fade"
        id={"AlertModal"}
        data-backdrop="static"
        data-keyboard="false"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="Alert"
        aria-hidden="false"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <div className="modal-title or-clr">{headTitle}</div>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="false">&times;</span>
              </button>
            </div>
            {modalBodyText}
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-outline-secondary"
                data-dismiss="modal"
              >
                {" "}
                Close{" "}
              </button>
            </div>
          </div>
        </div>
      </div>
      <DetailsUser
        userDetails={userDetails}
        CloseDetailUser={(el) => {
          $("#detailsUserModal").modal("hide");
        }}
        userDetEdit={userDetEdit}
        userTwoFactor={userActions}
        updateUser={updateUser}
        selectedProducts={selectedProducts}
        customerOrgVal={customerOrgVal}
        //customerNameVal={customerName}
      />
      <EditUser
        closeEdit={(el) => handleEdit()}
        userEditDetails={userEditDetails}
      />
      <AssignOrgEmail
        selectedProducts={selectedProducts}
        userObj={selectedGridProducts}
        onClick={(el) => {
          $("#SharedOrgEmailModal").modal("hide");
        }}
      />
      <UserEmailList emailListObj={emailListObj} />
      <SearchUser userSearchObj={userSearchObj} />
    </div>
  );
};

export default ListUser;
